// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__pz9Zz","options":"AnswerScale_options__24qRW","selected":"AnswerScale_selected__1O8mg"};